import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoselectComponent } from './components/autoselect/autoselect.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatOptionModule
  ],
  declarations: [
    AutoselectComponent
  ],
  exports: [
    AutoselectComponent
  ]
})
export class AutoselectModule { }
